import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {TermsConditionsEffects} from '@app/cart/store/effects/terms-conditions.effects';
import {termsAndConditionsReducer} from '@app/cart/store/reducers/terms-conditions.reducer';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {CartNotEmptyGuard, CheckoutAuthGuard, CheckoutPlaceOrderModule} from '@spartacus/checkout/base/components';
import {ConfigModule, I18nModule, UrlModule} from '@spartacus/core';
import {FormErrorsModule} from '@spartacus/storefront';
import {TermsAndConditionsModule} from '../checkout-terms-conditions/terms-and-conditions.module';
import {DcpCheckoutPlaceOrderComponent} from './dcp-checkout-place-order.component';

import '@sapudex/web-components/dist/Button.js';

@NgModule({
  imports: [
    CommonModule,
    CheckoutPlaceOrderModule,
    I18nModule,
    UrlModule,
    FormErrorsModule,
    RouterModule,
    ReactiveFormsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutPlaceOrder: {
          component: DcpCheckoutPlaceOrderComponent,
          guards: [CheckoutAuthGuard, CartNotEmptyGuard],
        },
      },
    }),
    TermsAndConditionsModule,
    StoreModule.forFeature('termsAndConditions', termsAndConditionsReducer),
    EffectsModule.forFeature([TermsConditionsEffects]),
    DcpCheckoutPlaceOrderComponent,
  ],
  exports: [DcpCheckoutPlaceOrderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DcpCheckoutPlaceOrderModule {}
